import React from 'react';

export { default } from './Form';

export const Heading = ({ children }) => (
  <div className="form__heading">
    {children}
  </div>
);